import { render } from "./EditableEmail.vue?vue&type=template&id=2a0339c8&lang=true"
import script from "./EditableEmail.vue?vue&type=script&lang=js"
export * from "./EditableEmail.vue?vue&type=script&lang=js"
script.render = render

export default script